import { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchBusquedas } from "../Slices/Busqueda/busquedaSlice";

/**
 * Hook personalizado para obtener resultados de búsqueda desde Redux.
 *
 * @returns {Object} Hook data
 * @returns {Array} hook.busquedas - Lista de resultados de búsqueda.
 * @returns {boolean} hook.isLoading - Indica si los datos están en proceso de carga.
 * @returns {any} hook.error - Contiene el error si ocurrió alguno al obtener los datos.
 * @returns {Function} hook.refetch - Función para volver a cargar los resultados.
 */
export const useSearchData = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const busquedas = useSelector(
    (state) => state.busqueda.busquedas,
    shallowEqual
  );

  const refetch = useCallback(async () => {
    setError(null);
    setIsLoading(true);

    try {
      await dispatch(fetchBusquedas()).unwrap();
    } catch (err) {
      setError(err);
      console.error("Error fetching busquedas:", err);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!busquedas || busquedas.length === 0) {
      refetch();
    }
  }, [busquedas, refetch]);

  return {
    busquedas: busquedas || [],
    isLoading,
    error,
    refetch,
  };
};
